<template>
  <footer class="footer">
    <!-- <AdSense></AdSense> -->
    <v-footer
    color="amber lighten-5"
    paddles
    >
    <v-row
    justify="center"
    no-gutters
    class="amber lighten-5 py-3 text-center grey--text"
    >
    <!-- <v-col>
    <tipping/>
    </v-col> -->
    <v-col
    class="amber lighten-5 py-1 text-center grey--text"
    cols="12"
    >
    <v-btn
    color="grey"
    text
    rounded
    class="footer__col1"
    href="https://twitter.com/MuggyTeaa"
    >
    製作者 むぎちゃ / MuggyTea
    </v-btn>
    励みになります！！
    <v-btn
    color="brack"
    rounded
    class="footer__col1"
    href="https://www.amazon.jp/hz/wishlist/ls/1Y072CCBYC99Q"
    >
    運営者を応援する<br>
    ほしい物リスト
    </v-btn>
    </v-col>
    <v-col class="amber lighten-5 py-1 text-center grey--text" cols="12">
    <strong>©️
    2019/1 - {{ new Date().getFullYear() }} -- Aitter - ついじぇね - </strong>
    </v-col>
    <v-col class="amber lighten-5 py-1 text-center grey--text" cols="12">
    <v-btn
    v-for="link in links"
    :key="link"
    color="grey"
    text
    rounded
    class="footer__col1"
    :to="link.path"
    >
    {{ link.name }}
    </v-btn>
    <v-btn
    color="grey"
    text
    rounded
    class="footer__col1"
    href="https://twitter.com/twigene_aitter"
    >
    公式Twitter
    </v-btn>
    <v-btn
    color="grey"
    text
    rounded
    class="footer__col1"
    href="https://forms.gle/euY2WbdRziXjFSUk9"
    >
    お問い合わせ
    </v-btn>
    </v-col>
    <v-btn
    color="white"
    text
    rounded
    class="footer__col1"
    >
      <Login />
    </v-btn>
    </v-row>
    </v-footer>
  </footer>
</template>

<script>
import Login from './Login'
import Index from '../pages/Index'
import TermsOfService from '../pages/TermsOfService'
import PrivacyPlicy from '../pages/PrivacyPolicy'
// import Adsense from '../common/AdSense'
export default {
  name: 'Footer',
  components: {
    Login
  },
  data: () => ({
    links: [
      { name: 'Home', path: '/', component: Index },
      { name: 'プライバシーポリシー', path: '/privacy-policy', component: PrivacyPlicy },
      { name: '利用規約', path: '/service', component: TermsOfService }
    ]
  }),
  computed: {
    isLogin () {
      return this.$store.getters['auth/check']
    },
    userinfo () {
      return this.$store.getters['auth/user']
    }
  }
}
</script>
<style>
.footer__col1 {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue